import { RadioGroup } from '@mui/material';
// @mui
import { alpha } from '@mui/material/styles';

//
import { useSettingsContext } from '../SettingsContext';
import {
  MaskControl,
  StyledCard,
  StyledCircleColor,
  StyledWrap,
} from '../styles';

const ColorPresetsOptions = () => {
  const { onChangeColorPresets, presetsOption, themeColorPresets } =
    useSettingsContext();

  return (
    <RadioGroup
      name="themeColorPresets"
      onChange={onChangeColorPresets}
      value={themeColorPresets}
    >
      <StyledWrap sx={{ gridTemplateColumns: 'repeat(3, 1fr)' }}>
        {presetsOption.map((color) => {
          const { name, value } = color;

          const selected = themeColorPresets === name;

          return (
            <StyledCard
              key={name}
              selected={selected}
              sx={{
                height: 48,
                ...(selected && {
                  bgcolor: alpha(value, 0.08),
                  borderColor: alpha(value, 0.24),
                }),
              }}
            >
              <StyledCircleColor color={value} selected={selected} />

              <MaskControl value={name} />
            </StyledCard>
          );
        })}
      </StyledWrap>
    </RadioGroup>
  );
};

export default ColorPresetsOptions;
